import React from "react";
import "./OnboardingThemePreview.scss";
import lightLogo from "../../../assets/images/orderwerks/orderwerks-logo-dark.svg";
import darkLogo from "../../../assets/images/orderwerks/orderwerks-logo-grey.svg";

type Props = {
    theme: "LIGHT" | "DARK";
};

export const OnboardingThemePreview: React.FC<Props> = (props) => {
    let logo = lightLogo;

    if (props.theme === "DARK") {
        logo = darkLogo;
    }

    return (
        <div className={"OnboardingThemePreview " + props.theme}>
            <div className={"header"}>
                <div className={"navBar"}>
                    <img src={logo} height={10} />
                </div>
            </div>

            <div className={"mainContent"}>
                <div className={"container"}>
                    <div className={"row"}>
                        <div className="col-6">
                            <div className={"content"}></div>
                        </div>
                        <div className="col-6">
                            <div className={"content"}></div>
                        </div>
                    </div>

                    <div className={"row mt-1"}>
                        <div className="col-12">
                            <div className={"content"}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
